'use strict';

const $ = window.jQuery;

module.exports = function () {
    if ( $('.archive-team').length <= 0 ) {
        return
    }

    $('.card-team').on('mouseenter', function () {
        $('.popin__figure').empty()
        $(this).find('.card-team__img').clone().appendTo( $('.popin__figure') )
        $('.popin__title').empty().append( $(this).data('title') )
        $('.popin__subtitle').empty().append( $(this).data('position') )
        $('.popin__content').empty().append( $(this).data('testimonial') )
    })
}
